/**
 * 新しい版（Service Worker）の反映を、ログイン中は保留するための小さな共有状態。
 * 共有端末は再読み込みするとログアウトされるので、反映はログイン画面が出ているときに行う。
 */
export const PENDING_RELOAD_KEY = 'catms_pending_reload';

let loginVisible = false;

export function setLoginScreenVisible(v: boolean): void { loginVisible = v; }
export function isLoginScreenVisible(): boolean { return loginVisible; }

/** ログイン画面の表示時に呼ぶ。保留中の更新があれば再読み込みして true を返す。 */
export function applyPendingReload(): boolean {
  let pending = false;
  try { pending = sessionStorage.getItem(PENDING_RELOAD_KEY) === '1'; } catch { /* noop */ }
  if (!pending) return false;
  try { sessionStorage.removeItem(PENDING_RELOAD_KEY); } catch { /* noop */ }
  window.location.reload();
  return true;
}
